import template from './decoration.jade';
import decoration from './../../../enums/decoration';

export default angular
    .module('cian.addForm.decoration', [])
    .directive('cianAfAboutObjectDecoration', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = decoration;
            if (!this.ad.decoration) {
                this.ad.decoration = this.items[0].value;
            }
        },
        controllerAs: 'decoration',
        template,
    }))
    .name;
